import Services from 'library/@e5p-services';
import { local } from 'library/@e5p-request/helpers';
import { storageKeys } from 'library/@e5p-request/config/constants';
import config from 'library/@e5p-request/config';
import * as Mutation from './mutations';

const userToken = local.getItem(storageKeys.token);
export const { axios, staticAxios, client, setHeaders } = new Services({
  baseURL: config?.api['REST-URL'] || null,
  staticURL: config?.api['REST-URL-STATIC'] || null,
  uri: config?.api['GRAPHQL-URI'] || null,
  headers: {
    Authorization: userToken ? `Bearer ${userToken}` : undefined,
  },
});

export default {
  createOAuthAuthorizationUrl: ({ vkn, bankCode, uid }, { signal } = {}) => {
    const mutation = Mutation.createOAuthAuthorizationUrl({ vkn, bankCode, uid });
    return client
      .mutate({
        ...mutation,
        ...(signal ? { context: { fetchOptions: { signal } } } : {}),
      })
      .then((res) => {
        const authorization = res?.data?.companyAccountMutation?.createOAuthAuthorizationUrl;
        if (!authorization || typeof authorization !== 'object') {
          throw new Error('INVALID_OAUTH_AUTHORIZATION_RESPONSE');
        }
        return authorization;
      });
  },
  saveDefaultCompanies: async ({ data }) => {
    try {
      return await client
        .mutate(Mutation.defaultCompanies({ userDefaultCompany: data }))
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return err;
        });
    } catch (error) {
      console.log(`Error ==>`, error);
    }
  },
  savePlaidAccountUid: async ({ bankCode = 0, vkn = '', companyCode = '', uid = '' }) => {
    if (!companyCode) return;
    try {
      return await client
        .mutate(Mutation.setPlaidCompanyCode({ bankCode, vkn, companyCode, uid }))
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.log(err);
          return err;
        });
    } catch (error) {
      console.log(`Error ==>`, error);
    }
  },
};
